module.exports = __webpack_public_path__ + "img/editerClient.759b2926.png";